import { EventBus } from '@primeuix/utils/eventbus';

const ThemeService = EventBus();

export default ThemeService;
